import { MailServiceConfig } from "../GeneratedClients/FreeBillApi"

const validateEmail = (mailServerConfig?: MailServiceConfig | null) => {
  var validation: {
    isValid: boolean
    message?: string
    actionButtonText?: string
  } = {
    isValid: true,
    message: undefined,
    actionButtonText: undefined,
  }
  if(!mailServerConfig || !mailServerConfig.email) {
    validation.isValid = false
    validation.message = "resources.mailServiceConfig.message.notConfigured"
    validation.actionButtonText = "resources.mailServiceConfig.action.configure"
  }
  return validation
}

export default validateEmail